import axios from './axiosConfig';
import { useQuery } from '@tanstack/react-query';
import { ObservationCycleScore } from 'types/api/envScales/ObservationCycleScore';

export type IndicatorScore = {
  indicator_id: number;
  score: number | null;
};

export type GetCycleScoresResponse = {
  observation_cycle_scores: ObservationCycleScore[];
};

export function getObservationCycleScores(cycleId: number) {
  return axios.get<GetCycleScoresResponse>(
    `/api/v1/observation_cycles/${cycleId}/scores`
  );
}

export function useGetObservationCycleScores(cycleId: number) {
  return useQuery({
    queryKey: ['envScales', 'observation_cycles', cycleId, 'scores'],
    queryFn: () => getObservationCycleScores(cycleId).then(res => res.data),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
}

export type UpdateObservationCycleScoresParams = {
  observation_cycle_score: {
    dimension_id: number;
    dimension_score?: number | null;
    dimension_notes?: string;
    indicator_scores?: IndicatorScore[];
  };
};

export function updateObservationCycleScores(
  cycleId: number,
  params: UpdateObservationCycleScoresParams
) {
  return axios.post(`/api/v1/observation_cycles/${cycleId}/scores`, params);
}
